import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { AIEmailAgentChatErrorView } from "app/pages/sales-intelligence/pages/ai-agent/components/AIEmailAgentChatErrorView/AIEmailAgentChatErrorView";

import { AIAgentEmailRefinePanel, type AIAgentEmailRefineProps } from "./AIAgentEmailRefinePanel";
import { StyledRefinePanelContainer, StyledRefinePanelInnerContainer } from "./styles";

export const AIAgentEmailRefinePanelWithErrorBoundary = (props: AIAgentEmailRefineProps) => {
    return (
        <StyledRefinePanelContainer data-automation="refine-panel">
            <Text
                fontVariant="h6"
                color={colorsPalettes.bluegrey[600]}
                padding="4px 0 16px"
                data-automation="refine-panel-title"
            >
                {translate("si.pages.ai_agent_email.panel.title")}
            </Text>

            <StyledRefinePanelInnerContainer>
                <ErrorBoundaryWithLogging FallbackComponent={AIEmailAgentChatErrorView}>
                    <AIAgentEmailRefinePanel {...props} />
                </ErrorBoundaryWithLogging>
            </StyledRefinePanelInnerContainer>
        </StyledRefinePanelContainer>
    );
};
